import PlaySession from "./PlaySession";

/**
* ScenarioPlaySession.js
* 
* Created on Oct 9, 2013, 3:26:16 PM
*
* @author Javier Quevedo-Fernandez for Ranj
**/
export default class ScenarioPlaySession extends PlaySession {
    constructor(scenarioID) {
        super();

        this._scenarioID = scenarioID;
        this._scores = [];
        this._keyMoments = [];
    }
;

    addKeyMomentEntry(entry) {
        this._keyMoments.push(entry);
    };


    getKeyMoments() {
        return this._keyMoments;
    };

    setKeyMoments(value) {
        this._keyMoments = value;
    };

    getScores() {
        return this._scores;
    };

    setScores(value) {
        this._scores = value;
    };

    getScenarioID() {
        return this._scenarioID;
    };

    setScenarioID(value) {
        this._scenarioID = value;
    };
}